// Simple header helper
import React, { useEffect, useMemo, useState, useCallback } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Paper,
  Stack,
  Typography,
  TextField,
  Button,
  Divider,
  Avatar,
  Box,
  ToggleButtonGroup,
  Chip,
  ToggleButton,
  Tooltip,
  IconButton,
} from "@mui/material";
import {
  Bolt,
  Smartphone,
  Close as CloseIcon,
  Save as SaveIcon,
  Close,
  Save,
  DesktopWindows,
  PhoneIphone,
  ContentCopy,
} from "@mui/icons-material";
import Swal from "sweetalert2";
import {
  createServiceCommunicationThunk,
  updateServiceCommunicationThunk,
} from "../../../../store/slices/CommunicationServiceSlice";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import EmailEditor from "./EmailEditor";
import SmsEditor from "./SmsEditor";

const { toast } = require("react-toastify");

const SectionHeader = ({ icon, title, right }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      mb: 2,
    }}
  >
    <Stack direction="row" spacing={1.2} alignItems="center">
      <Avatar
        sx={{
          width: 28,
          height: 28,
          bgcolor: "primary.light",
          color: "primary.main",
        }}
      >
        {icon}
      </Avatar>
      <Typography variant="subtitle1" fontWeight={600}>
        {title}
      </Typography>
    </Stack>
    {right}
  </Box>
);

export default SectionHeader;
